import { Injectable } from '@angular/core';
import { ActivatedRouteSnapshot, Resolve } from '@angular/router';
import { Observable } from 'rxjs';
import { AnalisesSpggProjetoService } from '../services/analises-spgg-projeto.service';

@Injectable({
  providedIn: 'root'
})
export class AnalisesSpggProjetoResolver implements Resolve<boolean> {

  constructor(private service: AnalisesSpggProjetoService) { }

  resolve(route: ActivatedRouteSnapshot): Observable<any> {
    return this.service.getById(route.params.id);
  }
}